import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth';
import { User } from './classes/user';
import { HttpErrorResponse } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

// Pagine con elenco a tutta larghezza.
const WIDE_LAYOUT_PATHS = ['/dashboard', '/clienti', '/fornitori', '/segnalatori'];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  isUserSignedIn = false;
  username?: string;
  wideLayout = false;

  constructor(private authService: AuthService,
              private router: Router) {
      this.updateLayout(this.router.url);
      this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe(event => this.updateLayout((event as NavigationEnd).urlAfterRedirects));

      this.authService.isUserSignedIn()
          .subscribe({
              next: () => {
                  this.isUserSignedIn = true;
              },
              error: () => {
                  this.isUserSignedIn = false;
              }
          });
  }

  ngOnInit() {
    this.authService.userSignedIn
        .subscribe({
              next: (user: User) => {
                this.username = user.Username;
                this.isUserSignedIn = true;
              },
              error: (err: HttpErrorResponse) => {
                console.log(err);
              }
            }
        );
    this.authService.userSignedOut
        .subscribe({
              next: () => {
                this.username = '';
                this.isUserSignedIn = false;
              },
              error: (err: HttpErrorResponse) => {
                console.log(err);
              }
            }
        );
  }

  private updateLayout(url: string) {
      const pathAndQuery = url.split('#')[0];
      const path = pathAndQuery.split('?')[0];
      const query = pathAndQuery.includes('?') ? pathAndQuery.slice(path.length + 1) : '';
      const vista = new URLSearchParams(query).get('vista');
      const fullWidthView = (vista === 'dns' || vista === 'iper')
          && /^\/richiesta\/\d+$/.test(path);
      this.wideLayout = WIDE_LAYOUT_PATHS.includes(path) || fullWidthView;
  }
}
